const statusAliases = [
  "started_company_profile", // 0
  "started_case_profile", // 1
  "accepting_terms", // 2
  "payment", // 3
  "paid", // 4
  "ready_for_review", // 5
  "review_in_progress", // 6
  "profile_change_required", // 7
  "transfer_data_to_UKVI", // 8
  "ready_for_submission", // 9
  "submitted_to_UKVI", // 10
  "posted_to_UKVI", // 11
  "approved_by_UKVI", // 12
  "rejected_by_UKVI", // 13
  "refused_by_UKVI", // 14
];

const capitalizeFirstLetter = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const statuses = statusAliases.map((alias) => {
  const words = alias.split("_");
  words[0] = capitalizeFirstLetter(words[0]);
  if (words.length > 1 && ["company", "case"].includes(words[1])) {
    words[1] = capitalizeFirstLetter(words[1]);
  }
  const index = words.indexOf("UKVI");
  if (index !== -1) words[index] = "Home Office";
  const label = words.join(" ");
  return { alias, label };
});
